import moment from 'moment';

export const getMonthYear = (dateString: string): string => {
  if (!dateString) return '';
  return moment(dateString).format('MMM YYYY');
};

export const formatDate = (dateString: string, format: string = 'MM/DD/YYYY'): string => {
  if (!dateString) return '';
  return moment(dateString).format(format);
};
